import React, { useState, useEffect, useRef } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { serviceList } from 'assets/data'
import { serviceList2 } from 'assets/data'
import { deviceList } from 'assets/data'

import { motion, AnimatePresence, cubicBezier } from 'framer-motion'

import ContactFloatingButton from 'components/ContactFloatingButton'

import DeviceSelect from 'assets/icons/home-device.svg'
import DownArrow from 'assets/icons/down-arrow.svg'

export default function Home() {
  const navigate = useNavigate()
  const scrollRef = useRef()
  const handleScroll = () => {
    const y = scrollRef.current.getBoundingClientRect().top + window.scrollY - 60
    window.scrollTo({ top: y, behavior: 'smooth' })
  }

  const [selectedService, setSelectedService] = useState(0)
  const [selectedDevice, setSelectedDevice] = useState(0)

  const serviceListLength = serviceList.length
  const deviceListLength = deviceList.length

  const opacityVariants = {
    hidden: { opacity: 0 },
    visible: { opacity: 1 },
  }

  const blurVariants = {
    start: {
      y: 50,
      scaleY: 1.1,
      scaleX: 0.7,
      transformOrigin: '50% 100%',
      opacity: 0,
      filter: 'blur(20px)',
    },
    end: {
      y: 0,
      scaleY: 1,
      scaleX: 1,
      transformOrigin: '50% 50%',
      opacity: 1,
      filter: 'blur(0)',
    },
  }
  const blurVariants2 = {
    start: {
      y: 200,
      scaleY: 1.1,
      scaleX: 0.7,
      transformOrigin: '50% 100%',
      opacity: 0,
      filter: 'blur(20px)',
    },
    end: {
      y: 0,
      scaleY: 1,
      scaleX: 1,
      transformOrigin: '50% 50%',
      opacity: 1,
      filter: 'blur(0)',
    },
  }

  useEffect(() => {
    const interval = setInterval(() => {
      setSelectedService(selectedService === serviceListLength - 1 ? 0 : selectedService + 1)
      setSelectedDevice(selectedDevice === deviceListLength - 1 ? 0 : selectedDevice + 1)
    }, 5000)

    return () => clearInterval(interval)
    // eslint-disable-next-line
  }, [selectedService, selectedDevice])

  useEffect(() => {
    const mainBannerContents = document.getElementById('main-banner_contents')
    const TARGET_HEIGHT = 300
    window.addEventListener('scroll', () => {
      const windowHeight = window.innerHeight < TARGET_HEIGHT ? TARGET_HEIGHT : window.innerHeight
      if (mainBannerContents) {
        const scrollY = window.scrollY
        if (scrollY > windowHeight * 2) return
        mainBannerContents.style.transform = `translateY(${scrollY * -0.3}px)`
        const process =
          scrollY / (windowHeight - TARGET_HEIGHT) > 1
            ? 1
            : scrollY / (windowHeight - TARGET_HEIGHT)
        mainBannerContents.style.opacity = 1 - process
      }
    })
    return () => window.removeEventListener('scroll', () => {})
  }, [])
  return (
    <div className='wrapper'>
      {/* 메인 베너 */}
      <div className='fixed flex flex-col items-center justify-center w-full h-[calc(100dvh-60px)]'>
        <div className='absolute top-0 left-0 w-full h-full opacity-50 -z-20'>
          <video
            autoPlay
            muted
            loop
            playsInline
            poster={require('assets/images/home-main-thumbnail.jpg')}
            className='object-cover w-full h-full'
          >
            <source src={require('assets/videos/home-main.webm')} />
            <source src={require('assets/videos/home-main.mp4')} />
          </video>
        </div>
        <div
          id='main-banner_contents'
          className='relative z-10 flex flex-col items-center justify-center gap-64'
        >
          <div className='flex flex-col items-center gap-8'>
            <motion.p
              initial={{ y: 50, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ duration: 0.5, delay: 0.8 }}
              className='text-h1-medium lg:text-title3-medium 3xl:text-title2-medium text-sk-default'
            >
              최적의 SW파트너
            </motion.p>
            <motion.p
              initial={{ y: 50, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ duration: 0.5, delay: 0.5 }}
              className='text-title1-bold lg:text-display2-bold 3xl:text-display1-bold text-sk-default'
            >
              시그마테크놀로지
            </motion.p>
          </div>
          <motion.div
            initial={{ y: 50, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.8, delay: 1.5 }}
            className='py-8 cursor-pointer md:py-12 button_black px-36 md:px-48'
          >
            <Link to='/contact/qnas/intro' className='cursor-pointer '>
              <motion.p className='text-body1-medium text-sk-white'>문의하기</motion.p>
            </Link>
          </motion.div>
        </div>
        <motion.div
          animate={{ y: [-25, 0, 0, -10, 0, 0, -15], opacity: [0.1, 0.4, 0.4, 0.4, 0.4, 0.4, 0] }}
          transition={{
            repeat: Infinity,
            repeatDelay: 0.75,
            duration: 3.25,
            times: [0, 0.32, 0.38, 0.6, 0.75, 0.85, 1.0],
            ease: cubicBezier(0.23, 1.0, 0.32, 1.0),
          }}
          className='absolute bottom-[20px] flex justify-center items-center w-[60px] h-[60px] cursor-pointer'
          onClick={handleScroll}
        >
          <img src={DownArrow} alt='' className='w-[45px] h-[45px] ' />
        </motion.div>
      </div>
      <div id='main-banner_blank' className='flex justify-center w-full h-screen'></div>
      <div className='h-[400px] w-full bg-gradient-to-b from-transparent to-white relative z-10'></div>
      <div id='main-contents' className='relative z-10 w-full overflow-visible bg-white '>
        {/* PORTFOLIO (스카이온 웹, 모바일) */}
        <div ref={scrollRef} className='py-40 sm:py-80'>
          <div className='relative pt-40 pb-[110px] flex flex-col items-center gap-32'>
            <div className='flex flex-col gap-12'>
              <p className='text-center text-body1-medium lg:text-h2-medium 3xl:text-h1-medium text-sk-info'>
                PORTFOLIO
              </p>
              <p className='text-center text-h1-semibold md:text-title3-bold lg:text-title2-bold 3xl:text-title1-bold text-sk-black'>
                언제 어디서나 유용하고 다양해진 기기만큼
                <br />
                중요해진 반응형 홈페이지 제작
              </p>
            </div>
            <div className='z-[2]'>
              <img
                src={require('assets/images/home-image1.png')}
                alt=''
                className='fade-in-bottom w-[626px]'
              />
            </div>
            <div className='bottom-[0px] absolute w-full h-[150px] home_background1 z-[1]'></div>
          </div>
        </div>

        {/* 시그마가 제작한 더 많은 홈페이지를 확인해보세요! + [포트폴리오 보기] 버튼 */}
        <div
          className='w-full bg-center bg-no-repeat bg-cover '
          style={{ backgroundImage: 'url(' + require('assets/images/home-banner1.png') + ')' }}
        >
          <div className='container w-full mx-auto '>
            <div className='px-[40px] lg:px-[100px] py-[40px] lg:py-[60px] flex flex-col sm:flex-row justify-between items-center gap-[20px] '>
              <motion.p
                variants={blurVariants}
                initial='start'
                whileInView='end'
                viewport={{ once: false }}
                transition={{
                  ease: cubicBezier(0.23, 1.0, 0.32, 1.0),
                  duration: 0.3,
                }}
                className='text-h1-semibold md:text-title3-bold lg:text-title2-bold 3xl:text-title1-bold text-sk-white'
              >
                시그마가 제작한
                <br />더 많은 홈페이지를 확인해보세요!
              </motion.p>
              <Link
                to='/portfolio'
                className='button_white 3xl:h-48 px-24 md:px-36 lg:px-48 py-10 md:py-12 hover:scale-[1.05] transition-all duration-[400ms]'
              >
                <p className='text-body3-medium md:text-body2-medium 3xl:text-body1-medium text-sk-default'>
                  포트폴리오 보기
                </p>
              </Link>
            </div>
          </div>
        </div>

        {/* 기획 / 디자인 / 프론트엔드 / 백엔드 */}
        <div className='flex flex-col gap-20 sm:gap-40'>
          <div className='pt-40 sm:pt-80 home_background2 '>
            <div className='container h-[585px] md:h-[410px] mx-auto px-[40px] lg:px-[100px] py-40 w-full flex flex-col md:flex-row justify-between items-center gap-[20px]'>
              <div className='flex flex-col w-full h-full gap-36'>
                <div className='flex flex-wrap gap-8 select-none'>
                  {serviceList.map((serviceItem, index) => (
                    <div
                      key={index}
                      className={`flex justify-center items-center shrink-0 px-[14px] xl:px-16 3xl:px-20 py-4 rounded-40 cursor-pointer transition-all duration-500 ${
                        selectedService === index
                          ? 'bg-sk-black text-sk-white border border-sk-black'
                          : 'bg-sk-white text-sk-default border border-sk-border'
                      }`}
                      onClick={() => setSelectedService(index)}
                    >
                      <p className='text-body2-medium'>{serviceItem.service}</p>
                    </div>
                  ))}
                </div>
                <AnimatePresence mode='wait'>
                  <motion.div
                    key={selectedService}
                    variants={opacityVariants}
                    initial='hidden'
                    animate='visible'
                    exit='hidden'
                    className='flex flex-col gap-36'
                  >
                    <div className='flex flex-col items-start gap-20'>
                      <div className='flex flex-col gap-6'>
                        <p className='text-body1-medium lg:text-h2-medium 3xl:text-h1-medium text-sk-info'>
                          홈페이지 {serviceList[selectedService].service}
                        </p>
                        <p className='whitespace-pre-wrap text-h1-semibold md:text-title3-bold lg:text-title2-bold 3xl:text-title1-bold text-sk-black'>
                          {serviceList[selectedService].title}
                        </p>
                      </div>
                      <p className='whitespace-pre-wrap text-body2-long-medium text-sk-info '>
                        {serviceList[selectedService].description}
                      </p>
                    </div>
                    <button
                      to={serviceList[selectedService].link}
                      className='hidden md:block text-center bg-sk-black rounded-40 w-[245px] px-48 py-12 select-none cursor-pointer'
                      onClick={() => navigate(serviceList[selectedService].link)}
                    >
                      <p className='text-body1-medium text-sk-white'>
                        {serviceList[selectedService].service} 자세히 보기
                      </p>
                    </button>
                  </motion.div>
                </AnimatePresence>
              </div>
              <AnimatePresence mode='wait'>
                <motion.div
                  key={selectedService}
                  variants={opacityVariants}
                  initial='hidden'
                  animate='visible'
                  exit='hidden'
                  className='max-xl:max-w-[450px]'
                >
                  <img src={serviceList[selectedService].img} alt='' />
                </motion.div>
              </AnimatePresence>
              <button
                to={serviceList[selectedService].link}
                className='block px-24 py-12 mx-auto text-center cursor-pointer select-none md:hidden bg-sk-black rounded-40'
                onClick={() => navigate(serviceList[selectedService].link)}
              >
                <p className='text-body3-medium text-sk-white'>
                  {serviceList[selectedService].service} 자세히 보기
                </p>
              </button>
            </div>
          </div>
          <div className='container pb-40 mx-auto sm:pb-80'>
            <div className='md:h-[416px]'>
              <AnimatePresence mode='wait'>
                <motion.div
                  key={selectedService}
                  variants={opacityVariants}
                  initial='hidden'
                  animate='visible'
                  exit='hidden'
                  className='px-[40px] lg:px-[100px] py-[40px] w-full flex flex-col md:flex-row justify-between items-center gap-[20px]'
                >
                  <div className=''>
                    <img src={serviceList[selectedService].img2} alt='' />
                  </div>
                  <div className='flex flex-col gap-28'>
                    <p className=' text-h1-semibold md:text-title3-bold lg:text-title2-bold 3xl:text-title1-bold text-sk-default text-end'>
                      {serviceList2[selectedService].description1}
                      <br className='' />
                      <span className='text-h1-semibold md:text-title3-bold lg:text-title2-bold 3xl:text-title1-bold text-[#015DC9]'>
                        {serviceList2[selectedService].description2}
                      </span>
                      {selectedService < 2 ? '를' : '을'}
                      <br />
                      확인해보세요
                    </p>
                    <p className='text-body2-long-medium text-sk-info text-end'>
                      버벅이는 홈페이지, 자꾸 터져버리는 상황 때문에 당황스러우신가요? &nbsp;
                      <br className='hidden sm:block' />
                      시그마테크놀로지를 만나면 달라질 수 있습니다
                    </p>
                  </div>
                </motion.div>
              </AnimatePresence>
            </div>
          </div>
        </div>

        {/* 홈페이지, 어떻게 준비해야할지 막막하신가요? + 문의하러 가기 */}
        <div
          className='w-full bg-center bg-no-repeat bg-cover '
          style={{ backgroundImage: 'url(' + require('assets/images/home-banner2.png') + ')' }}
        >
          <div className='container w-full mx-auto '>
            <div className='px-[40px] lg:px-[100px] py-[40px] lg:py-[60px] flex flex-col sm:flex-row justify-between items-center gap-[20px] '>
              <motion.div
                variants={blurVariants}
                initial='start'
                whileInView='end'
                viewport={{ once: false }}
                transition={{
                  ease: cubicBezier(0.23, 1.0, 0.32, 1.0),
                  duration: 0.3,
                }}
                className='flex flex-col gap-6'
              >
                <p className='text-h1-semibold md:text-title3-bold lg:text-title2-bold 3xl:text-title1-bold text-sk-white'>
                  홈페이지,
                  <br />
                  어떻게 준비해야할지 막막하신가요?
                </p>
                <p className='hidden md:block text-body1-long-regular text-sk-assistive'>
                  간단한 문답으로 고객님의 홈페이지 제작을 체계화할 수 있어요!
                </p>
              </motion.div>
              <Link
                to='/contact/qnas/intro'
                className='button_white 3xl:h-48 px-24 md:px-36 lg:px-48 py-10 md:py-12 hover:scale-[1.05] transition-all duration-[400ms] cursor-pointer'
              >
                <p className='text-body3-medium md:text-body2-medium 3xl:text-body1-medium text-sk-default'>
                  문의하러 가기
                </p>
              </Link>
            </div>
          </div>
        </div>

        {/* 반응형 홈페이지 */}
        <div className='py-80'>
          <div className='container mx-auto '>
            <div className='px-[40px] lg:px-[100px] flex flex-col gap-32'>
              <div className='flex flex-col gap-16'>
                <div className='flex flex-wrap justify-between gap-[20px]'>
                  {/* left */}
                  <div className='flex flex-col gap-16'>
                    <p className='text-body1-medium lg:text-h2-medium 3xl:text-h1-medium text-sk-info'>
                      반응형 홈페이지
                    </p>
                    <p className='text-h1-semibold md:text-title3-bold lg:text-title2-bold 3xl:text-title1-bold text-sk-default'>
                      어느 문으로 들어가도
                      <br />
                      같은 서비스를 받을 수 있도록
                    </p>
                  </div>
                  {/* right */}
                  {/* WEB/TABLET/MOBILE */}
                  <div className='flex gap-[14px] items-end grow justify-end'>
                    {deviceList.map((device, index) => (
                      <div
                        key={index}
                        className='relative flex flex-col gap-4 cursor-pointer select-none'
                        onClick={() => setSelectedDevice(index)}
                      >
                        <div className='flex justify-center'>
                          <img
                            src={`${
                              selectedDevice === index ? device.selectedImg : device.notSelectedImg
                            }`}
                            alt=''
                          />
                        </div>
                        <p
                          className={`text-body2-medium ${
                            selectedDevice === index ? 'text-[#0066FF]' : 'text-[#46474C]'
                          }`}
                        >
                          {device.device}
                        </p>
                        <div
                          className={`${
                            selectedDevice === index ? 'block' : 'hidden'
                          } absolute bottom-[-20px] left-1/2 transform -translate-x-1/2`}
                        >
                          <img src={DeviceSelect} alt='' />
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
                <div className='h-[1px] bg-sk-border'></div>
              </div>

              {/* WEB/TABLET/MOBILE 이미지 */}
              <div className='flex justify-center items-center h-[500px] overflow-hidden'>
                <AnimatePresence mode='wait'>
                  <motion.div
                    key={selectedDevice}
                    initial={{ y: 10, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    exit={{ y: -10, opacity: 0 }}
                    transition={{ duration: 0.2 }}
                  >
                    <img
                      src={`${
                        selectedDevice === 0
                          ? require('assets/images/home-image_web.png')
                          : selectedDevice === 1
                          ? require('assets/images/home-image_tablet.png')
                          : require('assets/images/home-image_mobile.png')
                      }`}
                      alt=''
                      className='max-h-[480px]'
                    />
                  </motion.div>
                </AnimatePresence>
              </div>
            </div>
          </div>
        </div>

        <div className='bg-[#F7F7F8] mb-[-220px] sm:mb-[-260px]'>
          <div className='px-[40px] lg:px-[100px] container mx-auto'>
            <div className='py-40 sm:py-[111px] flex flex-col items-center gap-24'>
              <p className='text-h1-semibold md:text-title3-bold lg:text-title2-bold 3xl:text-title1-bold text-sk-black'>
                시그마만의 특장점
              </p>
              <div className='flex flex-wrap justify-center gap-20'>
                {/* 1 */}
                <motion.div
                  variants={blurVariants2}
                  initial='start'
                  whileInView='end'
                  viewport={{ once: false }}
                  transition={{
                    ease: cubicBezier(0.23, 1.0, 0.32, 1.0),
                    duration: 0.3,
                  }}
                  className='max-w-[330px] h-[350px] flex flex-col justify-between px-28 py-28 rounded-12 bg-sk-white home_featureShadow'
                >
                  <div className='flex flex-col gap-12'>
                    <div className='flex flex-col gap-2'>
                      <p className='text-h2-semibold text-sk-info'>01</p>
                      <p className='text-h2-semibold sm:text-h1-semibold md:text-title3-bold text-sk-default'>
                        다양한 커버리지
                      </p>
                    </div>
                    <p className='text-body2-long-regular text-sk-info'>
                      백엔드, 프론트엔드, 서버. AI 개발자, 웹/앱 기획자, UXUI 디자이너 상주로
                      소프트웨어 종합 솔루션을 제공합니다
                    </p>
                  </div>

                  <div>
                    <img src={require('assets/images/home-illustration1.png')} alt='' />
                  </div>
                </motion.div>

                {/* 2 */}
                <motion.div
                  variants={blurVariants2}
                  initial='start'
                  whileInView='end'
                  viewport={{ once: false }}
                  transition={{
                    ease: cubicBezier(0.23, 1.0, 0.32, 1.0),
                    duration: 0.3,
                    delay: 0.4,
                  }}
                  className='max-w-[330px] h-[350px] flex flex-col justify-between px-28 py-28 rounded-12 bg-sk-white home_featureShadow'
                >
                  <div className='flex flex-col gap-12'>
                    <div className='flex flex-col gap-2'>
                      <p className='text-h2-semibold text-sk-info'>02</p>
                      <p className='text-h2-semibold sm:text-h1-semibold md:text-title3-bold text-sk-default'>
                        다양한 고객사
                      </p>
                    </div>
                    <p className='text-body2-long-regular text-sk-info'>
                      이미 여러 분야의 고객이 시그마의 서비스를 사용해주셨습니다
                      <br />
                      맞춤형 대응이 가능한 소프트웨어 전문가, 시그마입니다
                    </p>
                  </div>

                  <div>
                    <img src={require('assets/images/home-illustration2.png')} alt='' />
                  </div>
                </motion.div>

                {/* 3 */}
                <motion.div
                  variants={blurVariants2}
                  initial='start'
                  whileInView='end'
                  viewport={{ once: false }}
                  transition={{
                    ease: cubicBezier(0.23, 1.0, 0.32, 1.0),
                    duration: 0.3,
                    delay: 0.2,
                  }}
                  className='max-w-[330px] h-[350px] flex flex-col justify-between px-28 py-28 rounded-12 bg-sk-white home_featureShadow'
                >
                  <div className='flex flex-col gap-12'>
                    <div className='flex flex-col gap-2'>
                      <p className='text-h2-semibold text-sk-info'>03</p>
                      <p className='text-h2-semibold sm:text-h1-semibold md:text-title3-bold text-sk-default'>
                        빠르지만, 완벽하게
                      </p>
                    </div>
                    <p className='text-body2-long-regular text-sk-info'>
                      시그마는 완성도 높은 결과물을 빠른 속도로 제작 해드립니다
                    </p>
                  </div>

                  <div>
                    <img src={require('assets/images/home-illustration3.png')} alt='' />
                  </div>
                </motion.div>
              </div>
            </div>
          </div>
        </div>
        <ContactFloatingButton />
      </div>
    </div>
  )
}
